import http from "../../plugins/axios";

export default {
    tenantS3List(data) {
        return http.get({
            url: '/la/admin/tenant/S3/list',
            data
        })
    },
    tenantS3Add(data) {
        return http.post({
            url: `/la/admin/tenant/S3/add`,
            data
        });
    },
    tenantS3Edit(data) {
        return http.post({
            url: `/la/admin/tenant/S3/update`,
            data
        })
    },


};
